var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    className: "animate-spin",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9067 7.87433C17.4436 5.83231 21.5406 4.97434 25.5996 5.42568C29.6586 5.87702 33.4671 7.61403 36.469 10.3831C39.471 13.1522 41.5091 16.8084 42.286 20.8179C43.0628 24.8273 42.5377 28.9802 40.7872 32.67C39.0368 36.3599 36.1526 39.3937 32.5559 41.3283C28.9592 43.263 24.8382 43.9973 20.7946 43.424C16.751 42.8508 12.9965 41 10.0793 38.1418C7.16202 35.2836 5.2348 31.5678 4.57894 27.5367",
    stroke: "white",
    strokeWidth: 9.04688
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLoader);
export default __webpack_public_path__ + "static/media/white-loader.f3da80a3ba99b14ac69293c617827fcb.svg";
export { ForwardRef as ReactComponent };